// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionOurStory_container__2u8sA","preTitle":"SectionOurStory_preTitle__2QEa3","title":"SectionOurStory_title__X0BVJ","content":"SectionOurStory_content__2_8_g"};